import { Container, Typography } from "@mui/material";

export default function DownloadApps() {
  return (
    <Container sx={{ textAlign: "center" }}>
      <Typography variant="h5">دانلود نرم افزارها</Typography>
      <p>
        <big>
          <a href={`/apps/KBCamera.apk?${new Date().getTime()}`} title="K.B.Camera Download">
            دانلود اپلیکیشن جمع آوری تصاویر برای تهیه مجموعه دادگان
          </a>
        </big>
      </p>

      <p>
        <big>
          <a
            href={`/apps/app-release1.apk?${new Date().getTime()}`}
            title="K.B.Camera Download "
          >
            دانلود اپلیکیشن اندروید سرویس هوشمند تشخیص بیماری
          </a>
        </big>
      </p>

      <p>
        <big>
          <a
            href={`/apps/ios_source.tar.gz?${new Date().getTime()}`}
            title="K.B.Camera Download "
          >
            دانلود اپلیکیشن iOS سرویس هوشمند تشخیص بیماری
          </a>
        </big>
      </p>
    </Container>
  );
}
